import * as React from "react";
import EdButton from "../../../../generic/edButton";
import ObOrderLog from "../obOrderLog";

export interface IObIpoDtlsContentProps {
	data: any;
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ObIpoDtlsContent: React.FC<IObIpoDtlsContentProps> = (props) => {
	function onButtonClick(e: React.MouseEvent<HTMLButtonElement>) {
		console.log(e);
	}

	return (
		<div className="dtl_wrp ipo_detl_cont_wrap">
			<div className="dtl_wrp_rw ipo_info_row ">
				<div className="dtls_cont dtl_lft">
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">No.of Bids</div>
						<div className="dtl_amt taRight">{props.data.bids.length}</div>
					</div>
					{props.data.bids.map((bid: any, index: number) => (
						<div className="dtl_lbl" key={index}>
							<div className="dtl_hd taLeft">Price for Bid {index + 1}</div>
							<div className="dtl_amt taRight">{bid.atCutOff ? "₹" + props.data.bids.maxPrc : "₹" + bid.price || "--"}</div>
						</div>
					))}
				</div>
				<div className="dtls_cont dtl_right">
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">No. of Shares</div>
						<div className="dtl_amt taRight">
							{props.data.bids.reduce((a: number, b: any) => {
								return a + b.quantity;
							}, 0)}
						</div>
					</div>
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Blocked Amount</div>
						<div className="dtl_amt taRight">{props.data.upiAmtBlocked ? "₹" + props.data.upiAmtBlocked : "--"}</div>
					</div>
				</div>
			</div>
			<hr className="slim_line" />
			<div className="mf_info_row dtl_wrp_rw ">
				<div className="dtls_cont dtl_lft">
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Application No.</div>
						<div className="dtl_amt taRight">{!props.data.applicationNumber ? "NA" : props.data.applicationNumber || "--"}</div>
					</div>
				</div>
				<div className="dtls_cont dtl_right">
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Internal Ref No.</div>
						<div className="dtl_amt taRight">{props.data.referenceNumber || "--"}</div>
					</div>
				</div>
			</div>

			{/* buttons to perform different actions on click */}
			<div className="ob_btns btn_wrapper mg-t20 mg-b50">
				<div className="btn_left">
					{/* button to cancel */}
					<EdButton value="Cancel Order" btnTyp="secondary" onClick={props.onCancelClick} className="mg-r20" slim />
					{/* button to modify */}
					<EdButton value="Modify Order" btnTyp="secondary" onClick={onButtonClick} slim />
				</div>
			</div>
			{/* order log progress bar steps */}
			<ObOrderLog logs={props.data.applStatus.map((ord: any) => ({ time: ord.date, sts: ord.status }))} />
		</div>
	);
};

export default ObIpoDtlsContent;
